<section class="workflow-list-container">
  <ng-container>
    <gen-workflow-step *ngFor="let item of steps$|async;let i = index; trackBy:trackByFn"
                       [revision]="revision"
                       [stepTaglineField]="stepTagline"
                       [testElapsedTime]="testElapsedTime"
                       [stepItem]="item"
                       [activeIndex]="activeIndex"
                       [currentIndex]="i"></gen-workflow-step>
  </ng-container>
</section>
